/* eslint react/prop-types: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import {NavLink, withRouter} from 'react-router-dom';

import {Icon} from '@stubhub/bamboo';
import FormattedLink from '@stubhub/react-formatted-link';

const removeLastSlash = (href) => (href.endsWith('/') ? href.slice(0, -1) : href);

const NavItem = ({href, hasAlert, label, location, onClick, subItems}) => {
  const isActive = () =>
    subItems
      ? !!subItems.find(({href}) => isActiveSubmenu(href)())
      : location?.pathname?.includes(removeLastSlash(href));
  const isActiveSubmenu = (href) => () =>
    location?.pathname && removeLastSlash(location.pathname) === removeLastSlash(href);

  return (
    <li className={cs('Nav_Item', {active: isActive()})}>
      <FormattedLink
        href={href}
        to={href}
        LinkComp={NavLink}
        activeClassName="active"
        isActive={isActive}
        onClick={() => onClick(href)}
      >
        {label}
        {hasAlert && <Icon name="WarningFilled" size="md" className="Nav_Item__alert-icon" />}
      </FormattedLink>
      {subItems?.length ? (
        <ul className="subMenu">
          {subItems.map(({href, label, key}) => (
            <li key={key} className={cs({active: isActiveSubmenu(href)()})}>
              <FormattedLink
                href={href}
                to={href}
                LinkComp={NavLink}
                activeClassName="active"
                isActive={isActiveSubmenu(href)}
                onClick={() => onClick(href)}
              >
                {label}
              </FormattedLink>
            </li>
          ))}
        </ul>
      ) : null}
    </li>
  );
};

NavItem.propTypes = {
  href: PropTypes.string,
  hasAlert: PropTypes.bool,
  label: PropTypes.node,
  location: PropTypes.object,
  onClick: PropTypes.func,
  subItems: PropTypes.array,
};

export {NavItem};
export default withRouter(NavItem);
